import { axiosClient } from "./axiosClient";

export interface MarketplaceReportFilters {
  status?: 'pending' | 'reviewing' | 'resolved' | 'dismissed';
  reportType?: 'listing' | 'user' | 'review' | 'offer';
  reason?: 'spam' | 'scam' | 'inappropriate' | 'harassment' | 'fake' | 'counterfeit' | 'prohibited' | 'other';
  cursor?: string;
  limit?: number;
}

export interface ReviewReportData {
  resolution: string;
  actionTaken: 'none' | 'listing_removed' | 'user_suspended' | 'user_banned' | 'warning_sent' | 'listing_edited';
  adminNotes?: string;
}

// Fetch marketplace reports with filters
export const fetchMarketplaceReports = async (filters: MarketplaceReportFilters) => {
  const { data } = await axiosClient.get('/marketplace/reports', { params: filters });
  return data;
};

// Get single report by ID
export const getReportById = async (reportId: string) => {
  const { data } = await axiosClient.get(`/marketplace/reports/${reportId}`);
  return data;
};

// Review and resolve a report (admin only)
export const reviewReport = async (reportId: string, reviewData: ReviewReportData) => {
  const { data } = await axiosClient.put(`/marketplace/reports/${reportId}/review`, reviewData);
  return data;
};

// Dismiss a report (admin only)
export const dismissReport = async (reportId: string, reason?: string) => {
  const { data } = await axiosClient.put(`/marketplace/reports/${reportId}/dismiss`, {
    reason: reason || 'Invalid or duplicate report',
  });
  return data;
};

// Get report statistics
export const getReportStats = async () => {
  const { data } = await axiosClient.get('/marketplace/reports/stats');
  return data;
};
